import React from 'react';
import styles from './styles.css';

export const Link: React.FC<React.ComponentProps<'a'>> = props => {
  return <a className={styles['link']} {...props} rel="noreferrer" />;
};

Link.displayName = 'Link';
